import Vue from "vue";
import Router from "vue-router";
import BeforeYouTravel from "./views/1BeforeYouTravel.vue";
import TypeOfCoverage from "./views/2TypeOfCoverage.vue";
import TravelPlans from "./views/3TravelPlans.vue";
import TravellerAges from "./views/4TravellerAges.vue";
import Questionnaire1 from "./views/5Questionnaire1.vue";
import Questionnaire2 from "./views/6Questionnaire2.vue";
import Questionnaire3 from "./views/7Questionnaire3.vue";
import Quote from "./views/8Quote.vue";
import Notices from "./views/9Notices.vue";
import ApplicantInfo from "./views/10ApplicantInfo.vue";
import TravellerInfo from "./views/11TravellerInfo.vue";
import PaymentInfo from "./views/12PaymentInfo.vue";
import Confirmation from "./views/13Confirmation.vue";
import Reload from "./views/Reload.vue";

Vue.use(Router);

export default new Router({
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: "/Reload/:target",
      name: "Reload",
      component: Reload,
      props: true
    },
    {
      path: "/",
      name: "BeforeYouTravel",
      component: BeforeYouTravel,
      meta: {
        page: 1,
        step: 0,
        progressHeader: "",
        stepHeader: "text.page1_header1",
        instructions: "text.page1_text1",
        previousStep: "",
        nextStep: "/TypeOfCoverage"
      }
    },
    {
      path: "/TypeOfCoverage",
      name: "TypeOfCoverage",
      component: TypeOfCoverage,
      meta: {
        page: 2,
        step: 1,
        progressHeader: "text.step1_progressheader",
        stepHeader: "text.page2_header1",
        instructions: "text.page2_text1",
        previousStep: "/",
        nextStep: "/TravelPlans"
      }
    },
    {
      path: "/TravelPlans",
      name: "TravelPlans",
      component: TravelPlans,
      meta: {
        page: 3,
        step: 1,
        progressHeader: "text.step1b_progressheader",
        stepHeader: "text.page3_header1",
        instructions: "text.page3_text1",
        previousStep: "/TypeOfCoverage",
        nextStep: "/TravellerAges"
      }
    },
    {
      path: "/TravellerAges",
      name: "TravellerAges",
      component: TravellerAges,
      meta: {
        page: 4,
        step: 2,
        progressHeader: "text.step2a_progressheader",
        stepHeader: "text.page4_header1",
        instructions: "",
        previousStep: "/TravelPlans",
        nextStep: "/Quote"
      }
    },
    {
      path: "/Questionnaire1",
      name: "Questionnaire1",
      component: Questionnaire1,
      meta: {
        page: 5,
        step: 2,
        progressHeader: "text.step2_progressheader",
        stepHeader: "text.page5_header1",
        instructions: "",
        previousStep: "/TravellerAges",
        nextStep: "/Questionnaire2"
      }
    },
    {
      path: "/Questionnaire2",
      name: "Questionnaire2",
      component: Questionnaire2,
      meta: {
        page: 6,
        step: 2,
        progressHeader: "text.step2_progressheader",
        stepHeader: "text.page6_header1",
        instructions: "",
        previousStep: "/Questionnaire1",
        nextStep: "/Questionnaire3"
      }
    },
    {
      path: "/Questionnaire3",
      name: "Questionnaire3",
      component: Questionnaire3,
      meta: {
        page: 7,
        step: 2,
        progressHeader: "text.step2_progressheader",
        stepHeader: "text.page7_header1",
        instructions: "",
        previousStep: "/Questionnaire2",
        nextStep: "/Quote"
      }
    },
    {
      path: "/Quote",
      name: "Quote",
      component: Quote,
      meta: {
        page: 8,
        step: 3,
        progressHeader: "text.step3_progressheader",
        stepHeader: "text.page8_header1",
        instructions: "",
        previousStep: "/TravellerAges",
        nextStep: "/Notices"
      }
    },
    {
      path: "/Notices",
      name: "Notices",
      component: Notices,
      meta: {
        page: 9,
        step: 3,
        progressHeader: "text.step3b_progressheader",
        stepHeader: "text.page9_header1",
        instructions: "",
        previousStep: "/Quote",
        nextStep: "/ApplicantInfo"
      }
    },
    {
      path: "/ApplicantInfo",
      name: "ApplicantInfo",
      component: ApplicantInfo,
      meta: {
        page: 10,
        step: 4,
        progressHeader: "text.step4_progressheader",
        stepHeader: "text.page10_header1",
        instructions: "",
        previousStep: "/Notices",
        nextStep: "/TravellerInfo"
      }
    },
    {
      path: "/TravellerInfo",
      name: "TravellerInfo",
      component: TravellerInfo,
      meta: {
        page: 11,
        step: 4,
        progressHeader: "text.step4_progressheader",
        stepHeader: "text.page11_header1",
        instructions: "",
        previousStep: "/ApplicantInfo",
        nextStep: "/PaymentInfo"
      }
    },
    {
      path: "/PaymentInfo",
      name: "PaymentInfo",
      component: PaymentInfo,
      meta: {
        page: 12,
        step: 4,
        progressHeader: "text.step4_progressheader",
        stepHeader: "text.page12_header1",
        instructions: "",
        previousStep: "/TravellerInfo",
        nextStep: "/Confirmation"
      }
    },
    {
      path: "/Confirmation",
      name: "Confirmation",
      component: Confirmation,
      meta: {
        page: 13,
        step: 5,
        progressHeader: "text.step5_progressheader",
        instructions: "",
        stepHeader: "text.page13_header1",
        previousStep: "",
        nextStep: ""
      }
    }
  ]
});
